export default "__VITE_ASSET__CyKL2c$9__"